import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const NoteStackSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default NoteStackSVG;
